const PAYMOB_SDK_URL =
  'https://accept.paymob.com/unifiedcheckout/v1/paymob-checkout.js';

// Paymob SDK types
interface PaymobCheckoutButton {
  mount: (selector: string) => void;
}

interface PaymobInstance {
  checkoutButton: (clientSecret: string) => PaymobCheckoutButton;
}

interface PaymobConstructor {
  (publicKey: string): PaymobInstance;
}

declare global {
  interface Window {
    Paymob?: PaymobConstructor;
  }
}

let loadPromise: Promise<void> | null = null;

export const loadPaymobSdk = (): Promise<void> => {
  if (window.Paymob) return Promise.resolve();

  if (loadPromise) return loadPromise;

  loadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = PAYMOB_SDK_URL;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      loadPromise = null;
      reject(new Error('Failed to load Paymob SDK'));
    };
    document.head.appendChild(script);
  });

  return loadPromise;
};

export const getPaymobRedirectUrl = (
  clientSecret: string,
): string => {
  const publicKey = import.meta.env.VITE_PAYMOB_PUBLIC_KEY;
  return `https://accept.paymob.com/unifiedcheckout/?publicKey=${publicKey}&clientSecret=${clientSecret}`;
};

export const mountPaymobCheckout = (
  clientSecret: string,
  selector: string,
): void => {
  const publicKey = import.meta.env.VITE_PAYMOB_PUBLIC_KEY;
  if (!publicKey) {
    throw new Error('VITE_PAYMOB_PUBLIC_KEY is not configured');
  }

  if (!window.Paymob) {
    throw new Error('Paymob SDK not loaded');
  }

  const paymob = window.Paymob(publicKey);
  paymob.checkoutButton(clientSecret).mount(selector);
};
